<template>
  <div>
  <q-page padding>
    <div>
      <q-resize-observable @resize="onResize1"/>
      <article-path :withoutLink="true" :id="$route.params.parent_id" lbl=" "
                    v-if="$route.params.parent_id"/>
      <div v-else class="row" style="margin-right: 150px;">
        <q-btn v-if="tempItem.parent_id !== 'root'" round outline dense icon="edit" size="sm" color="warning" class="q-mr-sm" @click="articleModalMode = 2"></q-btn>
        <article-path :withoutLink="true" :id="tempItem.parent_id" lbl=" "/>
      </div>
      <!-- tiptap editor not working if used v-if with div -->
      <div class="row q-mt-sm">
        <q-field
            v-if="currentType !== 'v'"
            class="col-sm-9 q-mr-md"
            :error="$v.tempItem.title.$error"
            :error-label="$v.tempItem.title | errorLabel"
        >
          <q-input v-model.trim="tempItem.title" :autofocus="true" float-label="Заголовок"/>
        </q-field>
        <q-field
            class="col-sm-2"
            v-if="currentType !== 'v'"
        >
          <q-input
              v-model="_order"
              clearable type="number"
              :decimals="2" :step="0.01"
              min="-1000"
              max="1000"
              float-label="Порядок"
          />
        </q-field>
      </div>
      <p v-if="currentHasVariant">
        <q-btn-toggle outline rounded
                      v-model="avtype"
                      text-color="faded"
                      :options="[
                        {icon: 'fas fa-file-alt', value: 'a', toggleColor: 'primary'},
                        {icon: 'far fa-file-alt', value: 'v', toggleColor: 'warning'},
                      ]"
        />
        <span v-if="avtype === 'a'" class="text-primary">Опубликованный текст</span>
        <span v-else class="text-warning">Черновой текст</span>
      </p>
      <editor-menu-bar :editor="editor">
        <div class="menubar row" slot-scope="{ commands, isActive, menu }">
          <button
              :disabled="!undoEnabled"
              class="menubar__button"
              @click="commands.undo"
          >
            <q-icon name="undo"/>
          </button>

          <button
              :disabled="!redoEnabled"
              class="menubar__button"
              @click="commands.redo"
          >
            <q-icon name="redo"/>
          </button>
          <button class="menubar__button" :class="{ 'is-active': isActive.bold() }"
                  @click="commands.bold">
            <q-icon name="format_bold"/>
          </button>
          <button
              class="menubar__button"
              :class="{ 'is-active': isActive.italic() }"
              @click="commands.italic"
          >
            <q-icon name="format_italic"/>
          </button>

          <button
              class="menubar__button"
              :class="{ 'is-active': isActive.strike() }"
              @click="commands.strike"
          >
            <q-icon name="strikethrough_s"/>
          </button>

          <button
              class="menubar__button"
              :class="{ 'is-active': isActive.underline() }"
              @click="commands.underline"
          >
            <q-icon name="format_underlined"/>
          </button>

          <button
              class="menubar__button"
              :class="{ 'is-active': isActive.code() }"
              @click="commands.code"
          >
            <q-icon name="code"/>
          </button>

          <button
              class="menubar__button"
              :class="{ 'is-active': isActive.paragraph() }"
              @click="commands.paragraph"
          >
            <q-icon name="fa-paragraph"/>
          </button>

          <button
              class="menubar__button"
              :class="{ 'is-active': isActive.heading({ level: 1 }) }"
              @click="commands.heading({ level: 1 })"
          >
            H1
          </button>

          <button
              class="menubar__button"
              :class="{ 'is-active': isActive.heading({ level: 2 }) }"
              @click="commands.heading({ level: 2 })"
          >
            H2
          </button>

          <button
              class="menubar__button"
              :class="{ 'is-active': isActive.heading({ level: 3 }) }"
              @click="commands.heading({ level: 3 })"
          >
            H3
          </button>

          <button
              class="menubar__button"
              :class="{ 'is-active': isActive.bullet_list() }"
              @click="commands.bullet_list"
          >
            <q-icon name="format_list_bulleted"/>
          </button>

          <button
              class="menubar__button"
              :class="{ 'is-active': isActive.ordered_list() }"
              @click="commands.ordered_list"
          >
            <q-icon name="format_list_numbered"/>
          </button>

          <button
              class="menubar__button"
              :class="{ 'is-active': isActive.blockquote() }"
              @click="commands.blockquote"
          >
            <q-icon name="format_quote"/>
          </button>

          <button
              class="menubar__button"
              :class="{ 'is-active': isActive.code_block() }"
              @click="commands.code_block"
          >
            <q-icon name="code"/>
          </button>
          <button
              class="menubar__button"
              style="position: relative;"
          >
            <input
                type="file"
                multiple
                class="q-uploader-input absolute-full cursor-pointer"
                accept="image/*"
                @change="insertMedia"
            >
            <q-icon name="image"/>
          </button>
          <button
              class="menubar__button"
              style="position: relative;"
          >
            <input
                type="file"
                multiple
                class="q-uploader-input absolute-full cursor-pointer"
                accept="video/*"
                @change="insertMedia"
            >
            <q-icon name="videocam"/>
          </button>
          <button
              class="menubar__button"
              style="position: relative;"
          >
            <input
                type="file"
                multiple
                class="q-uploader-input absolute-full cursor-pointer"
                accept="audio/*"
                @change="insertMedia"
            >
            <q-icon name="mic"/>
          </button>
          <button
              class="menubar__button"
              style="position: relative;"
          >
            <input
                type="file"
                multiple
                class="q-uploader-input absolute-full cursor-pointer"
                accept="*"
                @change="insertMedia"
            >
            <q-icon name="fa fa-paperclip"/>
          </button>
          <editor-menu-bubble :editor="editor">
                <button
                    slot-scope="{ commands, isActive, getMarkAttrs, menu }"
                    class="menubar__button"
                    @click="showLinkMenu(getMarkAttrs('link'))"
                    :disabled="!menu.isActive"
                >
                  <q-icon name="fa-link" />
                </button>
          </editor-menu-bubble>
          <button
              class="menubar__button"
              @click="articleModalMode = 1"
              :disabled="!emptySelection"
          >
            <q-icon name="fas fa-book-reader"/>
          </button>
          <button class="menubar__button" @click="commands.createTable({rowsCount: 3, colsCount: 3, withHeaderRow: false })"
          >
            <svg viewBox="0 0 24 24" id="icon--table" width="16px" height="16px">
              <path fill-rule="evenodd" d="M17 17v5h2a3 3 0 0 0 3-3v-2h-5zm-2 0H9v5h6v-5zm2-2h5V9h-5v6zm-2 0V9H9v6h6zm2-8h5V5a3 3 0 0 0-3-3h-2v5zm-2 0V2H9v5h6zm9 9.177V19a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V5a5 5 0 0 1 5-5h14a5 5 0 0 1 5 5v2.823a.843.843 0 0 1 0 .354v7.646a.843.843 0 0 1 0 .354zM7 2H5a3 3 0 0 0-3 3v2h5V2zM2 9v6h5V9H2zm0 8v2a3 3 0 0 0 3 3h2v-5H2z">
              </path>
            </svg>
          </button>
          <editor-menu-bubble :editor="editor">
            <div
                slot-scope="{ commands, isActive, menu }"
                class="menububble"
                :class="{ 'is-active': isActive.table() }"
                style="left: 0px; top:30px;"
            >

              <button class="menubar__button" @click="commands.deleteTable" >
                <svg viewBox="0 0 24 24" id="icon--delete_table" width="16px" height="16px">
                  <path d="M19 14a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm-2.5 5.938h5a.937.937 0 1 0 0-1.875h-5a.937.937 0 1 0 0 1.875zM12.29 17H9v5h3.674c.356.75.841 1.426 1.427 2H5a5 5 0 0 1-5-5V5a5 5 0 0 1 5-5h14a5 5 0 0 1 5 5v2.823a.843.843 0 0 1 0 .354V14.1a7.018 7.018 0 0 0-2-1.427V9h-5v3.29a6.972 6.972 0 0 0-2 .965V9H9v6h4.255a6.972 6.972 0 0 0-.965 2zM17 7h5V5a3 3 0 0 0-3-3h-2v5zm-2 0V2H9v5h6zM7 2H5a3 3 0 0 0-3 3v2h5V2zM2 9v6h5V9H2zm0 8v2a3 3 0 0 0 3 3h2v-5H2z">
                  </path>
                </svg>
              </button>
              <button
                  class="menubar__button"
                  @click="commands.addColumnBefore"
              >
                <svg viewBox="0 0 24 24" id="icon--add_col_before" width="16px" height="16px"><path d="M19 14a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm2.5 5.938a.937.937 0 1 0 0-1.875h-1.25a.312.312 0 0 1-.313-.313V16.5a.937.937 0 1 0-1.875 0v1.25c0 .173-.14.313-.312.313H16.5a.937.937 0 1 0 0 1.875h1.25c.173 0 .313.14.313.312v1.25a.937.937 0 1 0 1.875 0v-1.25c0-.173.14-.313.312-.313h1.25zM2 19a3 3 0 0 0 6 0V5a3 3 0 1 0-6 0v14zm-2 0V5a5 5 0 1 1 10 0v14a5 5 0 0 1-10 0z"></path></svg>
              </button>
              <button
                  class="menubar__button"
                  @click="commands.addColumnAfter"
              >
                <svg viewBox="0 0 24 24" id="icon--add_col_after" width="16px" height="16px"><path d="M5 14a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm2.5 5.938a.937.937 0 1 0 0-1.875H6.25a.312.312 0 0 1-.313-.313V16.5a.937.937 0 1 0-1.875 0v1.25c0 .173-.14.313-.312.313H2.5a.937.937 0 1 0 0 1.875h1.25c.173 0 .313.14.313.312v1.25a.937.937 0 1 0 1.875 0v-1.25c0-.173.14-.313.312-.313H7.5zM16 19a3 3 0 0 0 6 0V5a3 3 0 0 0-6 0v14zm-2 0V5a5 5 0 0 1 10 0v14a5 5 0 0 1-10 0z"></path></svg>
              </button>
              <button
                  class="menubar__button"
                  @click="commands.deleteColumn"
              >
                <svg viewBox="0 0 24 24" id="icon--delete_col" width="16px" height="16px"><path d="M12.641 21.931a7.01 7.01 0 0 0 1.146 1.74A5 5 0 0 1 7 19V5a5 5 0 1 1 10 0v7.29a6.972 6.972 0 0 0-2 .965V5a3 3 0 0 0-6 0v14a3 3 0 0 0 3.641 2.931zM19 14a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm-2.5 5.938h5a.937.937 0 1 0 0-1.875h-5a.937.937 0 1 0 0 1.875z"></path></svg>
              </button>
              <button
                  class="menubar__button"
                  @click="commands.addRowBefore"
              >
                <svg viewBox="0 0 24 24" id="icon--add_row_before" width="16px" height="16px"><path d="M19 14a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm2.5 5.938a.937.937 0 1 0 0-1.875h-1.25a.312.312 0 0 1-.313-.313V16.5a.937.937 0 1 0-1.875 0v1.25c0 .173-.14.313-.312.313H16.5a.937.937 0 1 0 0 1.875h1.25c.173 0 .313.14.313.312v1.25a.937.937 0 1 0 1.875 0v-1.25c0-.173.14-.313.312-.313h1.25zM5 2a3 3 0 1 0 0 6h14a3 3 0 0 0 0-6H5zm0-2h14a5 5 0 0 1 0 10H5A5 5 0 1 1 5 0z"></path></svg>
              </button>
              <button
                  class="menubar__button"
                  @click="commands.addRowAfter"
              >
                <svg viewBox="0 0 24 24" id="icon--add_row_after" width="16px" height="16px"><path d="M19 0a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm2.5 5.938a.937.937 0 1 0 0-1.875h-1.25a.312.312 0 0 1-.313-.313V2.5a.937.937 0 1 0-1.875 0v1.25c0 .173-.14.313-.312.313H16.5a.937.937 0 1 0 0 1.875h1.25c.173 0 .313.14.313.312V7.5a.937.937 0 1 0 1.875 0V6.25c0-.173.14-.313.312-.313h1.25zM5 16a3 3 0 0 0 0 6h14a3 3 0 0 0 0-6H5zm0-2h14a5 5 0 0 1 0 10H5a5 5 0 0 1 0-10z"></path></svg>
              </button>
              <button
                  class="menubar__button"
                  @click="commands.deleteRow"
              >
                <svg viewBox="0 0 24 24" id="icon--delete_row" width="16px" height="16px"><path d="M13.255 15a6.972 6.972 0 0 0-.965 2H5A5 5 0 0 1 5 7h14a5 5 0 0 1 4.671 6.787 7.01 7.01 0 0 0-1.74-1.146A3 3 0 0 0 19 9H5a3 3 0 0 0 0 6h8.255zM19 14a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm-2.5 5.938h5a.937.937 0 1 0 0-1.875h-5a.937.937 0 1 0 0 1.875z"></path></svg>
              </button>
              <button class="menubar__button" @click="commands.toggleCellMerge">
                <svg viewBox="0 0 24 24" id="icon--combine_cells" width="16px" height="16px"><path d="M2 19a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v14zm-2 0V5a5 5 0 0 1 5-5h14a5 5 0 0 1 5 5v14a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5zm12-9a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1zm0 6a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0v-3a1 1 0 0 1 1-1zm0-13a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0V4a1 1 0 0 1 1-1z"></path></svg>
              </button>
              <button class="menubar__button" :class="{ 'is-active': isActive.table_header() }" @click="commands.toggleHeaderColumn">
                <svg viewBox="0 0 24 24" id="icon--add_col_before" width="16px" height="16px"><path stroke="black" stroke-width="1" fill="gray" d="M 6 19 a 3 3 0 0 0 6 0 V 5 a 3 3 0 1 0 -6 0 v 14 z"></path></svg>
              </button>
              <button class="menubar__button" :class="{ 'is-active': isActive.table_header() }" @click="commands.toggleHeaderRow">
                <svg viewBox="0 0 24 24" id="icon--add_col_before" width="16px" height="16px"><path stroke="black" stroke-width="1" fill="gray" d="M5 2a3 3 0 1 0 0 6h14a3 3 0 0 0 0-6H5z"></path></svg>
              </button>
            </div>
          </editor-menu-bubble>
        </div>
      </editor-menu-bar>
    </div>
    <div class="editor" :style="{ 'max-height': contentMaxHeight }">
      <editor-content class="editor__content" :editor="editor"/>
    </div>
    <q-field v-if="currentType !== 'v'">
      <q-resize-observable @resize="onResize2" />
      <q-chips-input add-icon="add_circle_outline" float-label="Тэги" v-model="tempItem.tags"/>
    </q-field>
    <publish-btn :type=currentType :notChanged="notChanged" :goView="goView" :doSave="saveDraft"
                 :doPublish="saveArt"/>
    <q-modal v-model="linkModalActive" @show="$refs.linkInput.focus()">
      <form class="group">
        <q-input ref="linkInput" type="url" v-model="linkUrl" float-label="Адрес ссылки" placeholder="http:\\" clearable />
        <q-checkbox v-model="linkInNew" label="В новом окне" />
        <div class="modal-buttons row">
        <q-btn flat color="primary" @click="linkModalActive = false" class="pull-right">
          Отменить
        </q-btn>
        <q-btn flat color="warning" @click="setLinkUrl" class="pull-right">
          Сохранить
        </q-btn>
        </div>
      </form>
    </q-modal>
    <q-modal v-model="articleModalActive" content-classes="group">
      <h6 v-if="articleModalMode === 1">Ссылка на статью</h6>
      <h6 v-else>Новое расположение статьи</h6>
      <tree-wiki :withDraft="false" :done="articleLinkDone" :disabledNode="avId" :disabledNotExpandable="articleModalMode === 2"></tree-wiki>
      <div class="row justify-end">
        <q-btn flat color="primary" @click="articleModalActive = false">Отменить</q-btn>
      </div>
    </q-modal>
  </q-page>
<media-inserter
    :editEnabled="true"
    ref="mediainserter"
    @mediaSaved="mediaSaved"
    @doNext="doNext"
/>
</div>
</template>


<script type="text/babel">
import { mapGetters } from 'vuex';
import Vue from 'vue';
import _ from 'lodash';
import { required, maxLength } from 'vuelidate/lib/validators';
import { withParams } from 'vuelidate/lib';
import ArticlePath from 'components/article-path.vue';
import PublishBtn from 'components/publish-btn.vue';
import MediaModal from 'components/media-modal.vue';
import MediaInserter from 'components/media-inserter.vue';
import { Editor, EditorContent, EditorMenuBar, EditorMenuBubble } from 'tiptap';
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  OrderedList,
  BulletList,
  ListItem,
  Bold,
  Code,
  Italic,
  Strike,
  Underline,
  History,
  Image,
  Table,
  TableHeader,
  TableCell,
  TableRow,
} from 'tiptap-extensions';
import Link from '../others/link-ext.js';
import RouterLink from '../others/router-link.js';
import Video from '../others/video.js';
import Audio from '../others/audio.js';
import File from '../others/file.js';
import TreeWiki from 'components/tree-wiki';

const emptyArticle = {
  title: '',
  content: '<p></p>',
  tags: [],
  order: 0,
  parent_id: null,
};

export default {
  name: 'wikiedit',
  components: {
    TreeWiki,
    ArticlePath,
    PublishBtn,
    EditorMenuBar,
    EditorContent,
    EditorMenuBubble,
    MediaModal,
    MediaInserter,
  },
  data() {
    return {
      loading: false,
      height1: 0,
      height2: 0,
      iniItem: Object.assign({}, emptyArticle),
      tempItem: Object.assign({}, emptyArticle),
      editor: new Editor({
        extensions: [
          new Blockquote(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new Image(),
          new BulletList(),
          new OrderedList(),
          new ListItem(),
          new Bold(),
          new Code(),
          new Italic(),
          new Link(),
          new RouterLink(),
          new Video(),
          new Audio(),
          new File(),
          new Strike(),
          new Underline(),
          new History(),
          new Table(),
          new TableHeader(),
          new TableCell(),
          new TableRow(),
        ],
        content: '<p>Текст загружается ...</p>',
        onUpdate: ({ getHTML, getJSON }) => {
          this.tempItem.content = getHTML();
          console.log(getJSON());
        },
      }),
      linkUrl: null,
      linkInNew: true,
      linkModalActive: false,
      articleModalMode: 0, // 0 - not active, 1 - link, 2 - place
    };
  },
  validations: {
    tempItem: {
      title: {
        required: withParams({ message: 'Введите заголовок' }, required),
        maxLength: withParams({ message: 'До 50 символов' }, maxLength(50)),
      },
    },
  },
  watch: {
    '$route.params.fullId': {
      handler: 'load',
      immediate: true,
    },
  },
  beforeDestroy() {
    this.editor.destroy();
  },
  beforeRouteLeave(to, from, next) {
    this.confirmExit()
      .then((res) => {
        if (res) next(); else next(false);
      });
  },
  computed: {
    ...mapGetters({
      currentFullId: 'wiki/currentFullId',
      currentType: 'wiki/currentType',
      versionTime: 'wiki/versionTime',
      currentHasVariant: 'wiki/currentHasVariant',
    }),
    emptySelection() {
      return true;
    },
    contentMaxHeight() {
      return `${this.$store.state.pageHeight - this.height1 - this.height2 - 56}px`;
    },
    authorName() {
      return this.$store.state.wiki.authorName;
    },
    avId() {
      return this.currentType === 'v' ? `a:${this.$utils.getId(this.currentFullId, 1)}` : this.currentFullId;
    },
    articleModalActive: {
      get() { return !!this.articleModalMode; },
      set(val) {
        if (!val) this.articleModalMode = 0;
      },
    },
    avtype: {
      get() {
        return this.currentType || 'a';
      },
      // сеттер:
      set(newValue) {
        if (newValue && newValue !== this.currentType) {
          this.confirmExit()
            .then((res) => {
              if (res) {
                this.$router.push(`/wikiedit/${newValue}:${this.$utils.getId(this.currentFullId, 1)}`);
                // this.load();
              } else {
                //
              }
            });
        }
      },
    },
    _order: {
      set(value) {
        const n = Number(value);
        this.tempItem.order = Number.isNaN(n) ? 0 : Math.min(1000, Math.max(-1000, n));
      },
      get() {
        return this.tempItem.order;
      },
    },
    undoEnabled() {
      return this.editor && this.editor.state.history$ && this.editor.state.history$.done.eventCount > 0;
    },
    redoEnabled() {
      return this.editor && this.editor.state.history$ && this.editor.state.history$.undone.eventCount > 0;
    },
    notChanged() {
      return _.isEqual(this.iniItem, this.tempItem);
    },
    addNew() {
      return (this.$route.name === 'wikiNew');
    },
  },
  methods: {
    move() {
      this.articleModalActive = true;
    },
    articleLinkDone(val) {
      console.log('articleLinkDone', val, this.$store.state.wiki.wikis[val].title);
      if (this.articleModalMode === 1) {
        this.editor.commands.routerLink({ to: `/wiki/${val}`, label: this.$store.state.wiki.wikis[val].title });
      } else {
        this.tempItem.parent_id = val;
      }
      this.articleModalActive = false;
    },
    showLinkMenu(attrs) {
      this.linkUrl = attrs.href;
      this.linkInNew = attrs.href ? attrs.target === '_blank' : true;
      this.linkModalActive = true;
    },
    setLinkUrl() {
      const attrs = { href: this.linkUrl };
      if (this.linkInNew) {
        attrs.target = '_blank';
      }
      this.editor.commands.link(attrs);
      this.linkModalActive = false;
      this.editor.focus();
    },
    mediaSaved(media) {
      console.log('mediaSaved', media);
      if (media.id) {
        const src = `/wikimedia?id=${media.id}`;
        let download;
        let title = media.name;
        if (media.reqType === 'file') {
          download = `${media.name}${media.ext}`;
          title = `\u21E9 ${title} (${this.$utils.formatSize(media.file_size)})`;
        }
        this.editor.commands[media.reqType]({
          src, title, alt: media.name, download,
        });
      }
    },
    doNext() { // process next mediaFile
      console.log('Do Next, media left -- ', this.mediaFiles.length);
      if (this.mediaFiles[0]) {
        this.$refs.mediainserter.init(this.mediaFiles.shift(), this.mediaFiles.length);
      }
    },
    onResize1(size) {
      console.log('onResize1', size.height);
      this.height1 = size.height;
    },
    onResize2(size) {
      console.log('onResize2', size.height);
      this.height2 = size.height;
    },
    insertMedia(e) { // start after click on button Вставить рисунок и т.п.
      console.log('start insertMedia', e);
      if (e.target.files.length > 10) {
        this.$store.commit('pushError', {
          error: 'Слишком много файлов!',
          message: 'Не более 10 штук',
        });
      }
      const files = Array.from(e.target.files).slice(0, 10);
      this.mediaFiles = [];
      files.forEach((f) => {
        if (f.size > 50 * 1024 * 1024) {
          this.$store.commit('pushError', {
            error: 'Слишком большой файл!',
            message: `${f.name}\nОбъем файла не должен превышать 50МБ`,
          });
        } else {
          const m = { file: f };
          this.mediaFiles.push(m);
        }
      });
      if (this.mediaFiles[0]) {
        let reqType = e.target.accept.split('/')[0]; // image, video or audio
        if (reqType === '*') reqType = 'file';
        Vue.nextTick(() => {
          this.$refs.mediainserter.init(this.mediaFiles.shift(), this.mediaFiles.length, reqType); // init by first file and set required type
          e.target.value = ''; // reset
        }, this);
      }
    },
    confirmExit() {
      return new Promise((resolve) => {
        if (this && !this.notChanged) {
          this.$q.dialog({
            title: 'Внимание',
            'prevent-close': true,
            message: 'При переходе изменения не будут сохранены!',
            ok: {
              flat: true,
              color: 'warning',
              label: 'Перейти',
            },
            cancel: {
              flat: true,
              color: 'info',
              label: 'Остаться',
            },
          })
            .then(() => {
              resolve(true);
            })
            .catch(() => {
              resolve(false);
            });
        } else {
          resolve(true);
        }
      });
    },
    load() {
      if (this.$route.name === 'wikiNew') { // new wiki
        this.iniItem.parent_id = this.$route.params.parent_id;
        this.tempItem.parent_id = this.$route.params.parent_id;
        document.title = '*Новая статья*';
        this.editor.setContent('');
      } else { // to load article
        // this.loading = true;
        this.$store.dispatch('wiki/loadWiki', { fullId: this.$route.params.fullId })
          .then(() => {
            Object.assign(this.iniItem, this.$store.state.wiki.currentItem);
            Object.assign(this.tempItem, this.$store.state.wiki.currentItem);
            document.title = this.iniItem.title;
            // this.loading = false;
            this.$nextTick(() => {
              console.log('*******************setContent');
              this.editor.setContent(this.iniItem.content);
            });
          })
          .catch((err) => {
            console.log(err);
            // this.loading = false;
          });
      }
    },
    saveDraft() { // save draft
      if (this.currentType === 'a') { // make variant from published article
        this.$q.dialog({
          title: 'Сохранение текста',
          'prevent-close': true,
          message: 'Текст статьи будет сохранен как черновик.\nЕсли черновик уже существует он будет заменен.',
          ok: {
            flat: true,
            color: 'warning',
            label: 'Сохранить',
          },
          cancel: {
            flat: true,
            color: 'info',
            label: 'Отмена',
          },
        })
          .then(() => {
            this.save(false);
          })
          .catch(() => false);
      } else {
        this.save(false); // save draft
      }
    },

    saveArt() {
      this.$q.dialog({
        title: 'Публикация статьи',
        'prevent-close': true,
        // eslint-disable-next-line
        message: 'Статья будет опубликована и доступна всем.\nВ соответствии с правилами, участники принимают на себя личную ответственность за содержание своих материалов.',
        ok: {
          flat: true,
          color: 'warning',
          label: 'Опубликовать',
        },
        cancel: {
          flat: true,
          color: 'info',
          label: 'Отмена',
        },
      })
        .then(() => {
          this.save(true);
        })
        .catch(() => false);
    },

    save(publish = false) {
      this.$v.tempItem.$touch();
      if (this.$v.tempItem.$invalid) {
        this.$store.commit('pushError', {
          error: 'Ошибка!',
          message: 'Неверный ввод',
        });
        return false;
      }
      // this turn off warning
      const bigChange = this.iniItem.parent_id !== this.tempItem.parent_id || this.iniItem.title !== this.tempItem.title || this.iniItem.order !== this.tempItem.order;
      Object.assign(this.iniItem, this.tempItem);
      this.$store.dispatch('wiki/saveWiki', {
        item: Object.assign({}, this.tempItem),
        publish,
        bigChange,
      })
        .then((savedFullId) => {
          this.$router.push(`/wiki/${savedFullId}`);
        })
        .catch((err) => {
          this.$store.commit('pushError', {
            error: err.error || 'Ошибка!',
            message: err.message || 'Возможно изменения не сохранены',
          });
          this.goView();
        });
    },
    goView() {
      if (this.$route.name === 'wikiNew') { // new wiki
        if (this.$route.params.parent_id === 'root') {
          this.$router.push('/wikis');
        } else {
          this.$router.push(`/wiki/${this.$route.params.parent_id}`);
        }
      } else {
        this.$router.push(`/wiki/${this.$route.params.fullId}`);
      }
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/pages/wiki-edit.vue